import firebase from './firebase';
const clientName = '/evoluir';
const formPost = (formName, formArray) => {
    var fireref = firebase.database().ref(clientName+formName);
    fireref.push(formArray);
};
const getData = (ref, action) => {
    var fireref = firebase.database().ref(clientName+ref);
    let arrayData = [];
    fireref.once('value', function (snapshot) {
        snapshot.forEach(function (childSnapshot) {
            arrayData[childSnapshot.key] = childSnapshot.val();
        });
        action(arrayData);
    });
    return arrayData;
};
export { formPost, getData };